import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';

var TableHead = function (_a) {
    var children = _a.children, theadProps = __rest(_a, ["children"]);
    return (jsx("thead", __assign({}, theadProps, { children: children })));
};

export { TableHead };
